import "@hotwired/turbo-rails"
import "@rails/activestorage"
import "@37signals/lexxy"
import "./controllers"
import { visitWhenFrameIsMissing } from "./helpers/frame_missing"
import { startRefreshGate } from "./helpers/refresh_gate"
import { startMorphGuard } from "./helpers/morph_guard"

visitWhenFrameIsMissing()
startRefreshGate()
startMorphGuard()
